mutation CancelPush($orderId: ID!) {
  cancelPush(input: { orderId: $orderId }) {
    order {
      id
    }
    errors
  }
}
